export default "__VITE_ASSET__aSIVLae3__"